export const saveButton = 'Save'

export const cancelButton = 'Cancel'
